import { Checkbox } from 'primereact/checkbox';
import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import * as myconst from "../../constants/index"
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';

interface arr_type {
  value: string;
  label: string;
}

const StepTwo = ({ handlePrev, handleNext, isLinear, goOnLast, methods, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const success_definition_value = watch('success_definition')
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }
  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['creator_why', 'career_goals', 'success_definition']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }
  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])
  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Why do you want to be a creator?</label>
                <Controller
                  name="creator_why"
                  control={methods.control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('creator_why').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("creator_why");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox">
                            <Checkbox
                              inputId={'creator_why'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                clearErrors('creator_why')
                                // If checked, add the value to the array; otherwise, remove it
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("creator_why")}
              </div>
            </div>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Are you looking for full-time career growth or just a side project?</label>
                <Controller
                  name="career_goals"
                  control={methods.control}
                  rules={{ required: "Please select a category" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('career_goals').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'career_goals'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('career_goals') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('career_goals') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("career_goals")}
              </div>
            </div>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">What does success look like to you?</label>
                <Controller
                  name="success_definition"
                  control={methods.control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('success_definition').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("success_definition");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox d-flex align-items-center">
                            <Checkbox
                              inputId={'success_definition'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                clearErrors('success_definition')
                                // If checked, add the value to the array; otherwise, remove it
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                            {option.label === 'Other' && success_definition_value.includes('other') &&
                              <InputText style={{ fontSize: "14px" }} className="ms-4" {...register("success_definition_other")} />
                            }
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("success_definition")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={handlePrev} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{'Next >'}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={goOnLast}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepTwo